export const ACCOUNT__PERMISSIONS = {
  PORTFOLIO: {
    VIEW_PRIVATE: {
      permissionGroupName: 'Przeglądanie niepublicznych portfolio mentorów',
      NONE: {
        dbName: 'ACCOUNT__PORTFOLIO__VIEW_PRIVATE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do nieopublikowanych portfolio.'
      },
      OWNED: {
        dbName: 'ACCOUNT__PORTFOLIO__VIEW_PRIVATE__OWNED',
        name: 'Własne niepubliczne portfolio',
        description: 'Możliwość przeglądania własnego portfolio, nawet jeśli nie jest opublikowane.'
      },
      ALL: {
        dbName: 'ACCOUNT__PORTFOLIO__VIEW_PRIVATE__ALL',
        name: 'Wszystkie portfolio opublikowane i nieopublikowane',
        description:
          'Możliwość przeglądania wszystkich portfolio mentorów, włącznie z nieopublikowanymi.'
      }
    },
    MANAGE: {
      permissionGroupName: 'Zarządzanie portfolio mentorów',
      NONE: {
        dbName: 'ACCOUNT__PORTFOLIO__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania portfolio mentorów.'
      },
      OWNED: {
        dbName: 'ACCOUNT__PORTFOLIO__MANAGE__OWNED',
        name: 'Własne portfolio',
        description:
          'Możliwość zarządzania własnym portfolio: edycja, dodawanie treści, zarządzanie widocznością.'
      },
      ALL: {
        dbName: 'ACCOUNT__PORTFOLIO__MANAGE__ALL',
        name: 'Wszystkie portfolio',
        description: 'Możliwość zarządzania wszystkimi portfolio'
      }
    },
    PUBLISH: {
      permissionGroupName: 'Publikowanie portfolio mentorów',
      NONE: {
        dbName: 'ACCOUNT__PORTFOLIO__PUBLISH__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości publikowania portfolio mentorów.'
      },
      OWNED: {
        dbName: 'ACCOUNT__PORTFOLIO__PUBLISH__OWNED',
        name: 'Własne portfolio',
        description: 'Możliwość publikowania własnego portfolio jako publicznie dostępne.'
      },
      ALL: {
        dbName: 'ACCOUNT__PORTFOLIO__PUBLISH__ALL',
        name: 'Wszystkie portfolio',
        description: 'Możliwość publikowania wszystkich portfolio.'
      }
    }
  },
  API_KEY: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie kluczami API',
      NONE: {
        dbName: 'ACCOUNT__API_KEY__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania kluczami API.'
      },
      SELF: {
        dbName: 'ACCOUNT__API_KEY__MANAGE__SELF',
        name: 'Własne klucze API',
        description: 'Możliwość tworzenia, przeglądania i unieważniania własnych kluczy API.'
      }
    }
  },
  // TODO: Add better permission description
  ADMIN_PANEL: {
    MANAGE: {
      permissionGroupName: 'Dostęp do panelu administratora',
      DISABLED: {
        dbName: 'ACCOUNT__ADMIN_PANEL__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do panelu administratora.'
      },
      ENABLED: {
        dbName: 'ACCOUNT__ADMIN_PANEL__MANAGE__ENABLED',
        name: 'Panel administratora',
        description: 'Możliwość zarządzania panelem administratora.'
      }
    }
  },
  DB_STUDIO: {
    ACCESS: {
      permissionGroupName: 'Dostęp do Drizzle Studio',
      DISABLED: {
        dbName: 'ACCOUNT__DB_STUDIO__ACCESS__DISABLED',
        name: 'Brak dostępu',
        description: 'Brak dostępu do Drizzle Studio.'
      },
      ENABLED: {
        dbName: 'ACCOUNT__DB_STUDIO__ACCESS__ENABLED',
        name: 'Drizzle Studio',
        description: 'Możliwość przeglądania bazy danych przez Drizzle Studio.'
      }
    }
  }
} as const
